import { logger } from '@amzn/atoz-shiftapp-metrics';
import { SwapRequestStatus } from '@amzn/atoz-shiftapp-types';
import { generateSwapToDaysMap } from '@amzn/atoz-shiftapp-utilities';
export var pendingSwapsToDaysMap = function (swaps) {
    if (!(swaps === null || swaps === void 0 ? void 0 : swaps.length)) {
        return {};
    }
    var _a = swaps[0], id = _a.id, swapFrom = _a.swapFrom, swapTo = _a.swapTo, status = _a.status;
    if (!id || !swapFrom || !swapTo || !status) {
        logger.emitError('pendingSwapsToDaysMap did not receive the necessary swaps.swaps data', {
            context: swaps[0]
        });
        return {};
    }
    return generateSwapToDaysMap(swaps, [SwapRequestStatus.Created]);
};
